module.exports = __webpack_public_path__ + "static/img/2.04ec96b.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner/2.png
// module id = yfGz
// module chunks = 1